module.exports = __webpack_public_path__ + "img/w_events.51db090a.svg";